import { FieldType } from '@wix/wix-data-schema-types'
import type { DefaultField } from '../types'

export const DEFAULT_COLLECTION_FIELDS: Record<string, DefaultField> = {
  LONG_DESCRIPTION: {
    fieldKey: 'longDescription',
    displayName: 'Long Description',
    type: FieldType.richText,
  },
  IMAGE: {
    fieldKey: 'image',
    displayName: 'Image',
    type: FieldType.image,
  },
  IMAGES_ALT_TEXT: {
    fieldKey: 'imagesAltText',
    displayName: 'Image’s alt text',
    type: FieldType.text,
  },
  SHORT_DESCRIPTION: {
    fieldKey: 'shortDescription',
    displayName: 'Short Description',
    type: FieldType.text,
  },
  TITLE: {
    fieldKey: 'title',
    displayName: 'Title',
    type: FieldType.text,
  },
}
